import { render } from "./waveformAnimation.vue?vue&type=template&id=ebedbae4"
import script from "./waveformAnimation.vue?vue&type=script&lang=js"
export * from "./waveformAnimation.vue?vue&type=script&lang=js"

import "./waveformAnimation.vue?vue&type=style&index=0&id=ebedbae4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__